module.exports = __webpack_public_path__ + "assets/LMidpointDetailed.5624f0c0c7732d88bc112dc3685de0f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LMidpointDetailed.png
// module id = 532
// module chunks = 0